import { render, staticRenderFns } from "./workView.vue?vue&type=template&id=68027793&scoped=true"
import script from "./workView.vue?vue&type=script&lang=js"
export * from "./workView.vue?vue&type=script&lang=js"
import style0 from "./workView.vue?vue&type=style&index=0&id=68027793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68027793",
  null
  
)

export default component.exports